import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Person from "./Person";
import Document from "./Accountings/Document";
import GridConfig from "./GridConfig";

export default class DebcredReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            configName: 'debcred_report',
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 56
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    refreshData() {
        this.httpPost("api/v1/report/debcred")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showPersonCard(id) {
        this.showComponents({ component: <Person Caller={this} Id={id} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "code", caption: "کد", show: true },
                { field: "name", caption: "نام", show: true },
                { field: "phone", caption: "تلفن", show: true },
                { field: "bed", caption: "گردش بدهکار", show: true },
                { field: "bes", caption: "گردش بستانکار", show: true },
                { field: "remain", caption: "مانده", show: true },
                { field: "tashkhis", caption: "تشخیص", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'name' && f.show) t.push({ flex: 3, field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showPersonCard(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'phone' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'tashkhis' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
            <div className="col-sm-2 text-left">
                <ul className="nk-block-tools g-3">
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('بدهکاران و بستانکاران')}><span>چاپ</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('بدهکاران و بستانکاران')}><span>PDF</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('بدهکاران و بستانکاران')}><span>اکسل</span></a>
                    </li>
                </ul>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}